export const isLocalStaging =
  import.meta.env.VITE_LOCAL_STAGING === '1' ||
  import.meta.env.VITE_LOCAL_STAGING === 'true';

export const StagingBanner = () => {
  if (!isLocalStaging) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          background:
            'linear-gradient(90deg, #01b832 0%, #20b49e 50%, #31cb55 100%)',
          color: '#ffffff',
          textAlign: 'center',
          fontWeight: 900,
          letterSpacing: '0.12em',
          padding: '14px 16px',
          textTransform: 'uppercase',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.35)',
          pointerEvents: 'none',
        }}
        data-testid="staging-banner"
      >
        LOCAL STAGING MODE
      </div>
    </>
  );
};
